{
  "setupWorkplaceStep": {
    "title": "Låt oss konfigurera din arbetsplats!",
    "description": "Du behöver slutföra de tre nästa stegen för att skapa en arbetsplats",
    "pill": {
      "setupNow": "Konfigurera nu"
    },
    "options": {
      "sso": {
        "title": "Anslut din SSO",
        "description": "Konfigurera enkel inloggning för att hantera åtkomst till din organisation.",
        "tooltipTitle": "Hjälptext",
        "buttonLabel": "Hantera"
      },
      "orgChat": {
        "title": "Anslut ditt organisationsschema",
        "description": "Importera din organisationsstruktur för att möjliggöra automatiserade arbetsflöden.",
        "tooltipTitle": "Hjälptext",
        "buttonLabel": "Konfigurera"
      },
      "communicationTool": {
        "title": "Anslut kommunikationsverktyg",
        "description": "Samla in feedback från anställda via ert kommunikationsverktyg.",
        "tooltipTitle": "Hjälptext",
        "buttonLabel": "Konfigurera"
      },
      "billing": {
        "title": "Ställ in fakturering",
        "description": "Lägg till din faktureringsinformation och välj en plan som passar dina behov.",
        "tooltipTitle": "Hjälptext",
        "buttonLabel": "Konfigurera"
      }
    }
  },
  "connectSsoStep": {
    "title": "Anslut din SSO-leverantör",
    "description": "Konfigurera enkel inloggning för att hantera åtkomst till din organisation",
    "backButton": "Gå tillbaka till inställningarna",
    "options": {
      "domain": {
        "title": "Verificar el dominio de la organización",
        "buttonLabel": "Verificar"
      },
      "provider": {
        "title": "Configurar el proveedor de identidad",
        "buttonLabel": "Configurar"
      }
    }
  },
  "connectOrgChatStep": {
    "title": "Anslut ditt organisationsschema",
    "description": "Importera din organisationsstruktur för att möjliggöra automatiserade arbetsflöden",
    "backButton": "Gå tillbaka till konfigurationen",
    "options": {
      "workday": { "title": "Workday", "buttonLabel": "Anslut" },
      "bamboo": { "title": "BambooHR", "buttonLabel": "Anslut" }
    }
  },
  "connectCommunicationToolStep": {
    "title": "Anslut ditt kommunikationsverktyg",
    "description": "Alla dagliga frågor kommer att samlas in via det kommunikationsverktyg du använder",
    "backButton": "Gå tillbaka till inställningarna",
    "options": {
      "slack": { "title": "Slack", "buttonLabel": "Anslut" },
      "teams": { "title": "Microsoft Teams", "buttonLabel": "Anslut" }
    }
  },
  "billingStep": {},
  "alertDialog": {
    "trigger": "Ställ in senare",
    "title": "Vill du hoppa över inställningen?",
    "description": "Om du hoppar över inställningen måste du konfigurera din arbetsplats senare. Vissa funktioner kanske inte är tillgängliga förrän inställningen är klar.",
    "actionButton": "Fortsätt med inställningen",
    "cancelButton": "Hoppa över inställningen"
  }
}
